module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pv"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0006#prog",
      "id": "rprog"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0007#ch01",
      "id": "rch01"
    }
  }, [_vm._v("1. The Psalms as the Christian’s Lament")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0007#bhaft0101",
      "id": "rbhaft0101"
    }
  }, [_vm._v("I. The Importance of Lament in the Psalter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0007#bh0101",
      "id": "rbh0101"
    }
  }, [_vm._v("II. The Loss and Gain of Lament in Our Western Society")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0007#bh0102",
      "id": "rbh0102"
    }
  }, [_vm._v("III. Lament in a Post-Critical Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0007#bh0103",
      "id": "rbh0103"
    }
  }, [_vm._v("IV. Biblical Causes for Lament")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0007#bh0104",
      "id": "rbh0104"
    }
  }, [_vm._v("V. The Old Testament Context for Lament")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0007#bh0105",
      "id": "rbh0105"
    }
  }, [_vm._v("VI. The Penitential Psalms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0008#ch02",
      "id": "rch02"
    }
  }, [_vm._v("2. Psalm 5: A Royal Petition for Protection from Malicious Liars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0008#ahaft0201",
      "id": "rahaft0201"
    }
  }, [_vm._v("Part I. Voice of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0008#bhaft0201",
      "id": "rbhaft0201"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0008#bh0201",
      "id": "rbh0201"
    }
  }, [_vm._v("II. Lament of the Scholar Monk, Jerome")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0008#bh0202",
      "id": "rbh0202"
    }
  }, [_vm._v("III. Jerome’s Interpretation of Psalm 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0008#bh0203",
      "id": "rbh0203"
    }
  }, [_vm._v("IV. The Continuing Influence of Jerome")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0008#ah0201",
      "id": "rah0201"
    }
  }, [_vm._v("Part II. Voice of the Psalmist: Translation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0008#ah0202",
      "id": "rah0202"
    }
  }, [_vm._v("Part III. Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0008#bhaft0202",
      "id": "rbhaft0202"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0008#bh0204",
      "id": "rbh0204"
    }
  }, [_vm._v("II. Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0008#ah0203",
      "id": "rah0203"
    }
  }, [_vm._v("Part IV. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0009#ch03",
      "id": "rch03"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "id": "pvi"
    }
  }), _vm._v("3. Psalm 6: Pursuit of Moral Excellence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0009#ahaft0301",
      "id": "rahaft0301"
    }
  }, [_vm._v("Part I. Voice of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0009#bhaft0301",
      "id": "rbhaft0301"
    }
  }, [_vm._v("I. Gregory of Nyssa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0009#bh0301",
      "id": "rbh0301"
    }
  }, [_vm._v("II. The Anagogy of “the Eighth Day”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0009#bh0302",
      "id": "rbh0302"
    }
  }, [_vm._v("III. The Pursuit of Excellence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0009#bh0303",
      "id": "rbh0303"
    }
  }, [_vm._v("IV. Gregory’s Interpretation of Psalm 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0009#bh0304",
      "id": "rbh0304"
    }
  }, [_vm._v("V. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0009#ah0301",
      "id": "rah0301"
    }
  }, [_vm._v("Part II. Voice of the Psalmist: Translation"), _c('br'), _vm._v("A Royal Petition for Vindication by Salvation from Death")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0009#ah0302",
      "id": "rah0302"
    }
  }, [_vm._v("Part III. Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0009#bhaft0302",
      "id": "rbhaft0302"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0009#bh0305",
      "id": "rbh0305"
    }
  }, [_vm._v("II. Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0009#ah0303",
      "id": "rah0303"
    }
  }, [_vm._v("Part IV. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0010#ch04",
      "id": "rch04"
    }
  }, [_vm._v("4. Psalm 7: A Royal Petition for Cosmic Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0010#ahaft0401",
      "id": "rahaft0401"
    }
  }, [_vm._v("Part I. Voice of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0010#bhaft0401",
      "id": "rbhaft0401"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0010#bh0401",
      "id": "rbh0401"
    }
  }, [_vm._v("II. The Words of Cush the Benjamite")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0010#bh0402",
      "id": "rbh0402"
    }
  }, [_vm._v("III. Literary and Contemporary Assassinations of David")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0010#bh0403",
      "id": "rbh0403"
    }
  }, [_vm._v("IV. The Exemplary Pastoral Theology of John Chrysostom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0010#bh0404",
      "id": "rbh0404"
    }
  }, [_vm._v("V. Chrysostom’s Commentary on Psalm 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0010#bh0405",
      "id": "rbh0405"
    }
  }, [_vm._v("VI. Charlemagne (c. 742-812)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0010#bh0406",
      "id": "rbh0406"
    }
  }, [_vm._v("VII. Alcuin (735-804)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0010#bh0407",
      "id": "rbh0407"
    }
  }, [_vm._v("VIII. Alfred the Great (c. 849-899)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0010#ah0401",
      "id": "rah0401"
    }
  }, [_vm._v("Part II. Voice of the Psalmist: Translation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0010#ah0402",
      "id": "rah0402"
    }
  }, [_vm._v("Part III. Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0010#bhaft0402",
      "id": "rbhaft0402"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0010#bh0408",
      "id": "rbh0408"
    }
  }, [_vm._v("II. Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0010#ah0403",
      "id": "rah0403"
    }
  }, [_vm._v("Part IV. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0011#ch05",
      "id": "rch05"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "id": "pvii"
    }
  }), _vm._v("5. Psalm 32: Forgiveness for the Justified")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0011#ahaft0501",
      "id": "rahaft0501"
    }
  }, [_vm._v("Part I. Voice of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0011#bhaft0501",
      "id": "rbhaft0501"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0011#bh0501",
      "id": "rbh0501"
    }
  }, [_vm._v("II. Augustine’s Hermeneutic of Divine Grace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0011#bh0502",
      "id": "rbh0502"
    }
  }, [_vm._v("III. The Augustinian “Paul” in Psalm 32")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0011#bh0503",
      "id": "rbh0503"
    }
  }, [_vm._v("IV. Augustine’s Exposition of Psalm 32")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0011#ah0501",
      "id": "rah0501"
    }
  }, [_vm._v("Part II. Voice of the Psalmist: Translation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0011#ah0502",
      "id": "rah0502"
    }
  }, [_vm._v("Part III. Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0011#bhaft0502",
      "id": "rbhaft0502"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0011#bh0504",
      "id": "rbh0504"
    }
  }, [_vm._v("II. Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0011#ah0503",
      "id": "rah0503"
    }
  }, [_vm._v("Part IV. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0011#bh0505",
      "id": "rbh0505"
    }
  }, [_vm._v("I. Doctrine of Sin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0011#bh0506",
      "id": "rbh0506"
    }
  }, [_vm._v("II. Doctrine of Punishment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0011#bh0507",
      "id": "rbh0507"
    }
  }, [_vm._v("III. Doctrine of Forgiveness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0011#bh0508",
      "id": "rbh0508"
    }
  }, [_vm._v("IV. Doctrine of Double Agency")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0012#ch06",
      "id": "rch06"
    }
  }, [_vm._v("6. Psalm 38: The Dance between Deserved and Undeserved Suffering")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0012#ahaft0601",
      "id": "rahaft0601"
    }
  }, [_vm._v("Part I. Voice of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0012#bhaft0601",
      "id": "rbhaft0601"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0012#bh0601",
      "id": "rbh0601"
    }
  }, [_vm._v("II. Ambrose as a Mystagogical Interpreter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0012#bh0602",
      "id": "rbh0602"
    }
  }, [_vm._v("III. Augustine (354-430) as Interpreter of the “Whole Christ”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0012#bh0603",
      "id": "rbh0603"
    }
  }, [_vm._v("IV. Theodore of Mopsuestia (350-429)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0012#bh0604",
      "id": "rbh0604"
    }
  }, [_vm._v("V. Theodoret of Cyrrhus (393-460)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0012#bh0605",
      "id": "rbh0605"
    }
  }, [_vm._v("VI. Cassiodorus’s Use of Job in Psalm 38")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0012#bh0606",
      "id": "rbh0606"
    }
  }, [_vm._v("VII. Medieval Penitential Commentaries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0012#ah0601",
      "id": "rah0601"
    }
  }, [_vm._v("Part II. Voice of the Psalmist: Translation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0012#ah0602",
      "id": "rah0602"
    }
  }, [_vm._v("Part III. Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0012#bhaft0602",
      "id": "rbhaft0602"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0012#bh0607",
      "id": "rbh0607"
    }
  }, [_vm._v("II. Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0012#ah0603",
      "id": "rah0603"
    }
  }, [_vm._v("Part IV. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0013#ch07",
      "id": "rch07"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "id": "pviii"
    }
  }), _vm._v("7. Psalm 39: The Lament of Silence in the Pastoral Theology of Erasmus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0013#ahaft0701",
      "id": "rahaft0701"
    }
  }, [_vm._v("Part I. Voice of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0013#bhaft0701",
      "id": "rbhaft0701"
    }
  }, [_vm._v("I. The Hermeneutic of Lay Nourishment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0013#bh0701",
      "id": "rbh0701"
    }
  }, [_vm._v("II. Erasmus as a Pastoral Theologian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0013#bh0702",
      "id": "rbh0702"
    }
  }, [_vm._v("III. Erasmus’ Use of Psalm 39 as a Pastoral Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0013#bh0703",
      "id": "rbh0703"
    }
  }, [_vm._v("IV. Erasmus’ Commentary on Psalm 39")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0013#ah0701",
      "id": "rah0701"
    }
  }, [_vm._v("Part II. The Voice of the Psalmist: Translation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0013#ah0702",
      "id": "rah0702"
    }
  }, [_vm._v("Part III. Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0013#bhaft0702",
      "id": "rbhaft0702"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0013#bh0704",
      "id": "rbh0704"
    }
  }, [_vm._v("II. Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0013#ah0703",
      "id": "rah0703"
    }
  }, [_vm._v("Part IV. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0014#ch08",
      "id": "rch08"
    }
  }, [_vm._v("8. Psalm 44: Lament in National Catastrophe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0014#ahaft0801",
      "id": "rahaft0801"
    }
  }, [_vm._v("Part I. Voice of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0014#bhaft0801",
      "id": "rbhaft0801"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0014#bh0801",
      "id": "rbh0801"
    }
  }, [_vm._v("II. Origen (c. 185-254)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0014#bh0802",
      "id": "rbh0802"
    }
  }, [_vm._v("III. Thomas Aquinas (1226-1274)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0014#bh0803",
      "id": "rbh0803"
    }
  }, [_vm._v("IV. Martin Luther (1483-1546)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0014#bh0804",
      "id": "rbh0804"
    }
  }, [_vm._v("V. John Calvin (1509-1564)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0014#ah0801",
      "id": "rah0801"
    }
  }, [_vm._v("Part II. Voice of the Psalmist: Translation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0014#ah0802",
      "id": "rah0802"
    }
  }, [_vm._v("Part III. Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0014#bhaft0802",
      "id": "rbhaft0802"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0014#bh0805",
      "id": "rbh0805"
    }
  }, [_vm._v("II. Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0014#ah0803",
      "id": "rah0803"
    }
  }, [_vm._v("Part IV. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0015#ch09",
      "id": "rch09"
    }
  }, [_vm._v("9. Psalm 102: The Prayer of an Afflicted Person")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0015#ahaft0901",
      "id": "rahaft0901"
    }
  }, [_vm._v("Part I. The Voice of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0015#bhaft0901",
      "id": "rbhaft0901"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0015#bh0901",
      "id": "rbh0901"
    }
  }, [_vm._v("II. Catholic or Traditional Repentance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0015#bh0902",
      "id": "rbh0902"
    }
  }, [_vm._v("III. Reformed or Evangelical Repentance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0015#bh0903",
      "id": "rbh0903"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "id": "pix"
    }
  }), _vm._v("IV. Courtly Repentance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0015#ah0901",
      "id": "rah0901"
    }
  }, [_vm._v("Part II. Voice of the Psalmist: Translation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0015#ah0902",
      "id": "rah0902"
    }
  }, [_vm._v("Part III. Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0015#bhaft0902",
      "id": "rbhaft0902"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0015#bh0904",
      "id": "rbh0904"
    }
  }, [_vm._v("II. Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0015#ah0903",
      "id": "rah0903"
    }
  }, [_vm._v("Part IV. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0016#ch10",
      "id": "rch10"
    }
  }, [_vm._v("10. Psalm 130: Lament of the Sinner before the Triune God of Grace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0016#ahaft1001",
      "id": "rahaft1001"
    }
  }, [_vm._v("Part I. Voice of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0016#bhaft1001",
      "id": "rbhaft1001"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0016#bh1001",
      "id": "rbh1001"
    }
  }, [_vm._v("II. Lament before the Triune God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0016#ah1001",
      "id": "rah1001"
    }
  }, [_vm._v("Part II. Voice of the Psalmist: Translation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0016#ah1002",
      "id": "rah1002"
    }
  }, [_vm._v("Part III. Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0016#bhaft1002",
      "id": "rbhaft1002"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0016#bh1002",
      "id": "rbh1002"
    }
  }, [_vm._v("II. Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0016#ah1003",
      "id": "rah1003"
    }
  }, [_vm._v("Part IV. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0017#ch11",
      "id": "rch11"
    }
  }, [_vm._v("11. Psalm 143: The Lament of the Justified")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0017#ahaft1101",
      "id": "rahaft1101"
    }
  }, [_vm._v("Part I. Voice of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0017#bhaft1101",
      "id": "rbhaft1101"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0017#bh1101",
      "id": "rbh1101"
    }
  }, [_vm._v("II. The Voice of "), _c('i', [_vm._v("Totius Christi")]), _vm._v(" According to Augustine (354-430)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0017#bh1102",
      "id": "rbh1102"
    }
  }, [_vm._v("III. Late Medieval Penitence and Denys the Carthusian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0017#bh1103",
      "id": "rbh1103"
    }
  }, [_vm._v("IV. The Reformation Commentary of John Calvin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0017#ah1101",
      "id": "rah1101"
    }
  }, [_vm._v("Part II. Voice of the Psalmist: Translation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0017#ah1102",
      "id": "rah1102"
    }
  }, [_vm._v("Part III. Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0017#bhaft1102",
      "id": "rbhaft1102"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0017#bh1104",
      "id": "rbh1104"
    }
  }, [_vm._v("II. Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0017#ah1103",
      "id": "rah1103"
    }
  }, [_vm._v("Part IV. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0018#glos",
      "id": "rglos"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0019#ch12",
      "id": "rch12"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "id": "px"
    }
  }), _vm._v("Index of Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0020#ch13",
      "id": "rch13"
    }
  }, [_vm._v("Index of Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eerpsalmschristian0021#ch14",
      "id": "rch14"
    }
  }, [_vm._v("Index of Scripture References")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5998850c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-psalmschristian-0005.vue
// module id = 66
// module chunks = 0